import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Helmet } from 'react-helmet';

const Seo = ({
	title,
	description,
	image,
	children,
	meta,
	...rest
}: {
	title?: string;
	description?: string;
	image?: string;
	children?: string;
	meta?: string | string[];
}) => {
	const { site } = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						title
						description
						author {
							name
						}
						social {
							image
						}
						keywords
					}
				}
			}
		`
	);

	const metaTitle = title || site.siteMetadata.title;
	const metaDescription = description || site.siteMetadata.description;
	const metaImage = image || site.siteMetadata.social.image;
	const keywords = site.siteMetadata.keywords;
	const metaProp = meta ? (Array.isArray(meta) ? meta : [meta]) : [];
	const mergedMeta = [
		{
			name: 'description',
			content: metaDescription,
		},
		{
			property: 'og:title',
			content: title,
		},
		{
			property: 'og:description',
			content: metaDescription,
		},
		{
			property: 'og:type',
			content: 'website',
		},
		{
			name: 'og:image',
			content: metaImage,
		},
		{
			name: 'twitter:card',
			content: 'summary',
		},
		{
			name: 'twitter:creator',
			content: site.siteMetadata.author?.name || '',
		},
		{
			name: 'twitter:title',
			content: title,
		},
		{
			name: 'twitter:image',
			content: metaImage,
		},
		{
			name: 'keywords',
			content: keywords,
		},
		...metaProp,
	];

	return (
		<Helmet
			htmlAttributes={{
				lang: 'en-US',
			}}
			title={metaTitle}
			meta={mergedMeta}
			{...rest}
		>
			{children}
		</Helmet>
	);
};

export default Seo;
